import { useMutation } from '@tanstack/react-query';

import { axiosPrivate } from 'app/utils';

function notifyOnboardingPreview(organisationId: string): Promise<void> {
  return axiosPrivate
    .post(`/v3/pharmacist/plus-websites/${organisationId}/notify-onboarding-preview`)
    .then(() => undefined);
}

export function useNotifyOnboardingPreview() {
  return useMutation({
    mutationFn: notifyOnboardingPreview,
  });
}
